<template lang="pug">
.d-loading
  transition( name='fade' appear )
    spinner(
      v-show='show'
      :radius='spinnerSize'
      :thickness='spinnerThickness'
      :color='spinnerColor'
      :speed='spinnerSpeed'
    )
</template>

<script lang="js">
import Spinner from '@/components/spinner'

export default {
  name: 'LoadingDisplay',
  mixins: [],
  components: { Spinner },
  props: {
    spinnerSize: [ String, Number ],
    spinnerThickness: [ String, Number ],
    spinnerColor: String,
    spinnerSpeed: String,
  },
  data() {
    return {
      show: false
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => { this.show = true })
  },
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.d-loading {
  position: relative;
  isolation: isolate;
}
</style>
